/**
 * Decode (without verifying) the payload of a JWT. Used by the 2FA email-link
 * flow to read the `add_session` claim from the link token, matching the Ember
 * login's `jwtDecode` usage. Returns `null` if the token can't be parsed.
 */
export function decodeJwtPayload<T = Record<string, unknown>>(token: string): T | null {
  try {
    const payload = token.split('.')[1];
    if (payload == null || payload === '') {
      return null;
    }
    // Base64url → base64, then pad to a multiple of 4.
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    // oxlint-disable-next-line typescript/consistent-type-assertions -- pre-existing assertion; replace with narrowing when touched
    return JSON.parse(atob(padded)) as T;
  } catch {
    return null;
  }
}
